import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import FilterButton from 'components/common/Filters/FilterButton'
import GlobalSearchFilterModal from '../GlobalSearchFilterModal'
import { injectProps } from 'helpers/utils'

const BOTGlobalSearch = ({
  displayGlobalSearch,
  filters,
  heading,
  placeholders: {
    leftContent = [],
    rightContent = []
  } = {},
  showFilterModal
}) =>
  <Wrapper data-at-globalsearch>
    <Heading data-at-globalsearch-heading>{ heading }</Heading>
    <Table>
      <SideBar>
        <GlobalSearchFilterModal />
        { leftContent }
      </SideBar>
      <Media.Mobile>
        {
          filters.length > 0 &&
            <CustomFilterButton title="Filter results" onClick={ showFilterModal } />
        }
      </Media.Mobile>
      <Results data-at-globalsearch-results>
        { injectProps(rightContent, { onGlobalSearchPage: displayGlobalSearch }) }
      </Results>
    </Table>
  </Wrapper>

BOTGlobalSearch.propTypes = {
  displayGlobalSearch: PropTypes.bool,
  filters: PropTypes.arrayOf(PropTypes.shape({
    filterGroup: PropTypes.string,
    navigation: PropTypes.arrayOf(PropTypes.shape())
  })),
  heading: PropTypes.string,
  placeholders: PropTypes.shape(),
  showFilterModal: PropTypes.func
}

export default BOTGlobalSearch

const Wrapper = styled.div`
  ${Media.mobile`
    padding: 0 16px;
  `}
`

const Heading = styled.h1`
  margin: 30px 0 30px;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(34, 600)}
  ${Media.desktop`
    margin-top: 40px;
  `}
  ${Media.mobile`
    margin: 60px 0 50px;
  `}
`

const Table = styled.div`
  ${Media.desktop`
    display: table;
    width: 100%;
  `}
`

const SideBar = styled.div`
  ${Media.desktop`
    display: table-cell;
    width: 228px;
    min-width: 228px;
    max-width: 228px;
    vertical-align: top;
  `}
`

const CustomFilterButton = styled(FilterButton)`
  margin-bottom: 10px;
`

const Results = styled.div`
  ${Media.desktop`
    display: table-cell;
    padding: 0 0 0 24px;
  `}
`
